import React from 'react'
import { Route } from 'react-router-dom'
import MainCollectionAndReturn from '../Views/Web/CollectionAndReturn/MainCollectionAndReturn'
import { FireSuppressionCreate, FireSuppressionEdit, FireSuppressionMain, FireSuppressionView, IndexFireSuppression } from '../Views/Web/CollectionAndReturn/FireSuppression/Index'
import { FireExtinguishersCreate, FireExtinguishersEdit, FireExtinguishersMain, FireExtinguishersView, IndexFireExtinguishers } from '../Views/Web/CollectionAndReturn/FireExtinguishers/Index'
import FormView from '../Views/Web/CollectionAndReturn/FireSuppression/FormView'
import EquipmentView from '../Views/Web/CollectionAndReturn/FireSuppression/EquipmentView'
import FeFormView from '../Views/Web/CollectionAndReturn/FireExtinguishers/FeFormView'
import FeEquipmentsView from '../Views/Web/CollectionAndReturn/FireExtinguishers/FeEquipmentsView'

function CollectionAndReturnRoutes() {
    return (
      <Route path="collectionAndreturn" element={<MainCollectionAndReturn />}>
            <Route path="fireExtinguisher" element={<FireExtinguishersMain/>} >
           <Route index element={<IndexFireExtinguishers/>} />
           <Route path='create' element={<FireExtinguishersCreate/>} />
           <Route path='edit/:fireExtinguishersEditId' element={<FireExtinguishersEdit/>} />
           <Route path='view/:fireExtinguishersViewId' element={<FireExtinguishersView/>} />
           <Route path='form/:fireExtinguishersViewId' element={<FeFormView/>} />
           <Route path='equipments/:fireExtinguishersViewId' element={<FeEquipmentsView/>} />
          
          </Route>
         <Route path="fireSuppression" element={<FireSuppressionMain/>} >
           <Route index element={<IndexFireSuppression/>} />
           <Route path='create' element={<FireSuppressionCreate/>} />
           <Route path='edit/:fireSuppressionEditId' element={<FireSuppressionEdit/>} />
           <Route path='view/:fireSuppressionViewId' element={<FireSuppressionView/>} />
           <Route path='form/:fireSuppressionViewId' element={<FormView/>} />
           <Route path='equipment/:fireSuppressionViewId' element={<EquipmentView/>} />

          </Route>     
      </Route>
    )
  }
  
  export default CollectionAndReturnRoutes